import { c as _c } from "react/compiler-runtime";
import { AppLayout } from '@src/components/sco/AppLayout';
import { PitchDeckChatPanel } from '@src/components/sco/PitchDeckAuditor/chat/PitchDeckChatPanel';
import { PitchDeckView } from '@src/components/sco/PitchDeckAuditor/model/types';
import { DeckNav } from '@src/components/sco/PitchDeckAuditor/nav/DeckNav';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { HubspotHideChatStyles } from '@src/components/sco/utilities/HubspotChatHandler/HubspotHideChatStyles';
import { ReactNode } from 'react';

/**
 * The Pitch Deck Auditor layout shell.
 *  - While the deck is still processing/failed → a single centered panel (the processing UI).
 *  - Once audited → the three-panel workspace: slide nav / main analysis / "Ask Pitchy" chat.
 * Panel ids intentionally end in -nav / -main / -aside so AppLayout applies its named styling.
 */
export function PitchDeckAuditorShell(t0) {
  const $ = _c(23);
  const {
    deck,
    activeSlideId,
    onSelectSlide,
    onReplaced,
    mainPanel
  } = t0;
  if (!deck.isAudited) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ScoSiteNavBar />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== mainPanel) {
      t2 = <AppLayout header={t1} panels={[{
        id: "pitch-deck-single",
        children: mainPanel
      }]} />;
      $[1] = mainPanel;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ScoSiteNavBar />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      base: true,
      lg: false
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== activeSlideId || $[6] !== deck || $[7] !== onReplaced || $[8] !== onSelectSlide) {
    t3 = {
      id: "pitch-deck-nav",
      defaultWidth: 300,
      minWidth: 260,
      maxWidth: 380,
      isResizable: true,
      resizeHandlePosition: "right",
      useDrawerBreakpoints: t2,
      children: <DeckNav activeSlideId={activeSlideId} deck={deck} onReplaced={onReplaced} onSelectSlide={onSelectSlide} />
    };
    $[5] = activeSlideId;
    $[6] = deck;
    $[7] = onReplaced;
    $[8] = onSelectSlide;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== mainPanel) {
    t4 = {
      id: "pitch-deck-main",
      children: mainPanel
    };
    $[10] = mainPanel;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      base: true,
      xl: false
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== activeSlideId || $[14] !== deck) {
    t6 = {
      id: "pitch-deck-aside",
      defaultWidth: 420,
      minWidth: 340,
      maxWidth: 560,
      isResizable: true,
      resizeHandlePosition: "left",
      scrollable: false,
      useDrawerBreakpoints: t5,
      children: <PitchDeckChatPanel activeSlideId={activeSlideId} deck={deck} />
    };
    $[13] = activeSlideId;
    $[14] = deck;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t6) {
    t7 = <AppLayout header={t1} panels={[t3, t4, t6]} />;
    $[16] = t3;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <HubspotHideChatStyles />;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7) {
    t9 = <>{t7}{t8}</>;
    $[21] = t7;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}